export const appRoutes = {
    HOME: "/",
    PRIVACY_POLICY: "/privacy-policy",
    TERMS_OF_SERVICE: "/terms-of-service",
    HELP_CENTRE: "/help-centre",
    FACEBOOK_DATA_DELETION: "/facebook-data-deletion",
    // Other Pages
    catchAll: "**",
};